import Subscription from "@/modules/subscription/subscription.js";

export const refreshOneTimePackages = ({commit}) => {
    return new Promise((resolve, reject) => {
        Subscription.oneTimePackages()
            .then(response => {
                commit('ONE_TIME_PACKAGES',response.data); 
            })
            .catch(err => {
                reject(err);
            });
    });
}